// Copyright (c) 2018 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
// in compliance with the License. You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software distributed under the License
// is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
// or implied. See the License for the specific language governing permissions and limitations under
// the License.

import { assert } from 'chai';
import DefaultThrottler from '../../src/throttler/default_throttler';

describe('DefaultThrottler should', () => {
  it('throttle everything', () => {
    const throttler = new DefaultThrottler(true);
    throttler.setProcess({});
    assert.isNotOk(throttler.isAllowed('key'));
    throttler.close();
  });

  it('throttle nothing', done => {
    const throttler = new DefaultThrottler();
    throttler.setProcess({});
    assert.isOk(throttler.isAllowed('key'));
    throttler.close(done);
  });
});
